module.exports = __webpack_public_path__ + "static/img/mazzo-di-carte-5.a5d4901.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mazzo-di-carte-5.svg
// module id = ISL7
// module chunks = 1